/* eslint-disable react-hooks/rules-of-hooks */
import { Fragment } from "react";
import styled from "styled-components";
import iconLoading from "assets/icons/icon_loading.gif";
import NoPartner from "layouts/NoPartner";

// components
import { Header, BottomNavbar, Error } from "layouts";
import { useSelector } from "react-redux";

const MainLayout = ({
  headerProps,
  withBottomTab,
  withHeader,
  children,
  backgroundColor,
  withPartner,
  isLoading = false,
  isError = false,
  onScroll = undefined,
  onRefresh = undefined,
}) => {
  const state = withPartner ? useSelector((state) => state.partner) : {};

  return (
    <OuterWrapper backgroundColor={backgroundColor}>
      <Wrapper>
        {withPartner && state.isNoPartner ? (
          <NoPartner />
        ) : (
          <Fragment>
            {withHeader && (
              <OuterHeaderWrapper>
                <HeaderWrapper>
                  <Header {...headerProps} />
                </HeaderWrapper>
              </OuterHeaderWrapper>
            )}
            <Content
              id="content"
              className={isLoading ? "loading" : null}
              onScroll={onScroll ? onScroll : null}
            >
              <HeaderPadding
                withHeader={withHeader}
                withBackButton={headerProps.withBackButton}
              />
              {isError ? (
                <Error
                  mode={withHeader ? "child" : withBottomTab ? "page" : ""}
                  onRefresh={onRefresh}
                />
              ) : isLoading ? null : (
                children
              )}
              <BottomPadding withBottomTab={withBottomTab} />
            </Content>
          </Fragment>
        )}
        {withBottomTab && (
          <BottomNavbarWrapper>
            <InnerBottomWrapper>
              <BottomNavbar />
            </InnerBottomWrapper>
          </BottomNavbarWrapper>
        )}
      </Wrapper>
    </OuterWrapper>
  );
};

// styled
const OuterWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "transparent"};
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
`;

const OuterHeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 8;
`;

const HeaderWrapper = styled.div`
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  max-width: 768px;
  background-color: ${(props) => props.theme.colors.background};
`;

const BottomNavbarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 99;
`;

const InnerBottomWrapper = styled.div`
  height: 100%;
  margin: auto;
  align-items: center;
  max-width: 768px;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 24px 24px 0 0;
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.025);
`;

const Content = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 768px;
  overflow: auto;
  overflow-behavior: none;
  &.loading:after {
    content: "";
    position: fixed;
    left: 0;
    top: 50px;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85) url(${iconLoading}) no-repeat center
      center / 50px;
    z-index: 8;
  }
  &.hidden {
    overflow: hidden;
  }
`;

const HeaderPadding = styled.div`
  height: ${(props) =>
    props.withHeader ? (props.withBackButton ? "52px" : "60px") : 0};
`;

const BottomPadding = styled.div`
  height: ${(props) => (props.withBottomTab ? "60px" : 0)};
`;

export default MainLayout;
